import React, { useEffect, useState } from 'react';

function TypedText({ strings, typeSpeed = 45, backSpeed = 35, className, style, loop = false }) {
  const [text, setText] = useState('');
  const [stringIndex, setStringIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    if (!strings || strings.length === 0) {
      return undefined;
    }

    const current = strings[stringIndex] || '';
    const doneTyping = !deleting && charIndex === current.length;
    const doneDeleting = deleting && charIndex === 0;
    const delay = doneTyping ? 1200 : deleting ? backSpeed : typeSpeed;

    const timeout = window.setTimeout(() => {
      if (doneTyping) {
        setDeleting(true);
        return;
      }

      if (doneDeleting) {
        const nextIndex = stringIndex + 1;
        setStringIndex(loop ? nextIndex % strings.length : Math.min(nextIndex, strings.length - 1));
        setDeleting(false);
        return;
      }

      const nextCharIndex = deleting ? charIndex - 1 : charIndex + 1;
      setCharIndex(nextCharIndex);
      setText(current.slice(0, nextCharIndex));
    }, delay);

    return () => window.clearTimeout(timeout);
  }, [backSpeed, charIndex, deleting, loop, stringIndex, strings, typeSpeed]);

  return <span className={className} style={style}>{text}</span>;
}

export default TypedText;
